export interface IItem {
    className: string,
    count: number,
}

export interface IVariant {
    _id?: string,
    name: string,
    color?: string,
    imageUrl?: string,
    className: string,
    items?: IItem[],
}

export interface IAdminProduct {
    _id: string,
    name: string,
    description: string,
    type: string,
    className?: string,
    count: number,
    priority: number,
    imageUrl: string,
    price: number,
    categories: string[],
    servers: string[],
    items?: IItem[],
    personal?: boolean,
    variants?: IVariant[],
}

export const PRODUCT_TYPES: { value: string, label: string }[] = [
    { value: "product", label: "Предмет" },
    { value: "products", label: "Набір предметів" },
    { value: "vehicle", label: "Авто" },
    { value: "set", label: "Сет" },
    { value: "priority", label: "Пріоритет" },
];

export const typeLabel = (type: string) => PRODUCT_TYPES.find((t) => t.value === type)?.label ?? type;

// Предмети редагуються текстом: «ClassName кількість» у кожному рядку — так їх зручно вставляти й копіювати
export const itemsToText = (items?: IItem[]) => (items ?? []).map((i) => `${i.className} ${i.count}`).join("\n");

export const textToItems = (text: string): { items: IItem[], errors: string[] } => {
    const items: IItem[] = [];
    const errors: string[] = [];

    text.split("\n").map((l) => l.trim()).filter(Boolean).forEach((line, i) => {
        const [className, rawCount] = line.split(/[\s×x*]+/i).filter(Boolean);
        const count = rawCount === undefined ? 1 : Number(rawCount);
        if (!/^[A-Za-z0-9_]+$/.test(className ?? "")) {
            errors.push(`Рядок ${i + 1}: класнейм лише з латиниці, цифр і _`);
        } else if (!Number.isInteger(count) || count < 1) {
            errors.push(`Рядок ${i + 1}: кількість має бути цілим числом від 1`);
        } else {
            items.push({ className, count });
        }
    });

    return { items, errors };
};

// Підказка назви кольору з класнейму (Hatchback_02_Blue -> Синій)
const COLOR_HINTS: [RegExp, string, string][] = [
    [/black/i, "Чорний", "#1e1f22"],
    [/white/i, "Білий", "#e8e8e8"],
    [/blue/i, "Синій", "#2f5fd0"],
    [/red/i, "Червоний", "#c0392b"],
    [/green/i, "Зелений", "#3f8f4f"],
    [/grey|gray/i, "Сірий", "#8d939c"],
    [/yellow/i, "Жовтий", "#e5b80b"],
    [/wine/i, "Бордовий", "#7a1f2b"],
    [/rust/i, "Іржавий", "#9c5b2e"],
];

export const guessColor = (product: IAdminProduct): { name: string, color: string } => {
    const hint = COLOR_HINTS.find(([re]) => re.test(product.className ?? ""));
    return hint ? { name: hint[1], color: hint[2] } : { name: product.name, color: "#888888" };
};

// Ті самі правила, що й на сервері: https:// або картинка, завантажена на наш сервер
export const isImageUrl = (url: string) =>
    /^https:\/\/[^\s"'<>]+$/.test(url) || /^\/api\/uploads\/[a-f0-9]{32}\.(png|jpg|webp|gif)$/.test(url);
